
import Components from "slotworks/components/components";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import { SoundEvent } from "slotworks/sound/sound-events";
import SoundManager from "slotworks/sound/sound-manager";
import Contract from "slotworks/utils/contract";

export function StopSpinCommand(spinRecord: SpinRecord, quickSpin: boolean = false) {
    return new Contract<void>((resolve) => {
        Components.matrix.stopTransition(spinRecord.stops, spinRecord.reelset, quickSpin, spinRecord.anticipations).then(() => {
            if (spinRecord && spinRecord instanceof FreespinRecord) {
                SoundManager.event(SoundEvent.end_freespin);
            } else {
                SoundManager.event(SoundEvent.end_spin);
            }
            resolve(null);
        });
    });
}



// WEBPACK FOOTER //
// ./~/slotworks/commands/comms/stop-spin-command.ts